<template>
	<div class="shopIndex" >
		<div class='shopIndexTop'>
			<img class="shopIndexBgImg"  :src="shopInfoData.shop_banner" alt="">
				 <div class='shopIndexTopBg' >
					<div class="goodListHead" >
						 <div class="headLeft"  @click="$router.go(-1)" >
							 <img src="../../assets/img/icon/Arrowleft.png" alt="">
						 </div>
						 <div class="centerSearch" @click="goserch()">
							<van-search
								  v-model="value"
								  shape="round"
								  placeholder="搜索"
								/>
						 </div> 
						 <div class="headRight"  >
							<img @click="goNotice" src="../../assets/img/icon/notice.png" alt="">
						 </div>
					 </div>
					 <div class="shopInfo clearfix" >
						 <div class="infoLogo" >
							 <img :src="shopInfoData.shop_logo? shopInfoData.shop_logo : $store.state.defaultdp" alt="">
							 <span>{{shopInfoData.shop_name}}</span>
						 </div>
						 <div class="collection" @click="collections">
							 <img  v-if="collectionActive == 1"  src="../../assets/img/icon/shopCollection.png" alt="">
							 <img v-else src="../../assets/img/icon/shopGoCollection.png" alt="">
						 </div>
					 </div>
				  </div>
			</div>
			<div class="tapBarBox" :class="{isios:isios}" safe-area-inset-bottom>
		<div class="index" num=0  v-show='active == 0' >
			<div class="shopIndexContent" >
						<div class="shopContentList" @click="goLuckDraw(item.id)" v-for="(item,inds) in luckDrawData" :key="inds+'1'" >
							<img :src="item.pic_url" alt="">
							<div class="ContentListText" >
								<p>{{item.title}}</p>
							</div>
						</div>
						<div class="shopContentList" v-for="(obj,index) in shopAdsData" :key="index+'2'">
							<img :src="obj.ad_picture" alt="">
							<div class="ContentListText" >
								<p>{{obj.ad_title}}</p>
							</div>
						</div>
				</div>
				<div>
					<verticalItemList :data='shopGoodsData'></verticalItemList>
				</div>
			</div>
			<div class="goods" v-show='active == 2' >
				<div class="goodsTopTool" >
                    <div class="toolBox" >
						<div>
							<span @click="comprehensive()" >综合</span>
						</div>
						<div>
							 <span  @click="salesVolume()" >销量</span>
						</div>
						<div>
							 <span @click="priceSort()" >价格</span> <img src="../../assets/img/icon/higher.png" alt="">
						</div>
					</div>
					 <div class="toolheadRight" @click="togglePermu" >
						<img v-if=" permutation == 'rect' " src="../../assets/img/icon/rectShow.png" alt="">
						<img v-if=" permutation ==  'vertical' " src="../../assets/img/icon/verticalShow.png" alt=""> 
					</div>
				</div>
					<div  v-if=" permutation == 'vertical' " >
						<listOfItems :data='goosList' ></listOfItems>
					</div>
					<div  v-if=" permutation == 'rect' " >
					    <verticalItemList :data='goosList' ></verticalItemList>
					</div>
			</div>
			<div class="kinds" v-show='active == 1' >
				<van-tree-select height="calc(100% - 172px)"  :items="leftItems"  :main-active-index.sync="kindActive"  @click-nav="onClickNavs" >
				<template slot="content" >
					<div class="kind">
						<div class="kindBox">
							<!-- <h5 class="kindTitle">{{item.shop_cat_name}}</h5> -->
							<div class="kindList"  v-for="(item,i) in smallKind" :key="i+'3'">
								<div class="kindListBox"  @click='goDetail()'  v-for="(boj,indexs) in item.children" :key="indexs+'4'"> 
									<img :src="boj.pic_url" alt="">
									<p>{{boj.shop_cat_name}}</p>
								</div>
							</div>
						</div>
					</div>
				</template>
			</van-tree-select>
			</div>
		</div>
		<div class="shopfootNav" >
			<van-tabbar v-model="active" active-color="#FF0000" safe-area-inset-bottom >
			  <van-tabbar-item>
				<span>首页</span>
				  <template #icon="props">
					<img :src="props.active ? icon.homeActive : icon.homeinActive" class="sindex" />
				  </template>
			  </van-tabbar-item>
			  <van-tabbar-item >
				  <span>分类</span>
					<template #icon="props">
					  <img :src="props.active ? icon.sortActive : icon.sortinActive" class="skinds" />
					</template>
			 </van-tabbar-item>
			  <van-tabbar-item >
				 <span>商品</span>
				   <template #icon="props">
					 <img :src="props.active ? icon.commodityActive : icon.commodityinActive" class="sgoods" />
				   </template>
				</van-tabbar-item>
			   <van-tabbar-item @click="toService()" >
				   <span>客服</span>
					 <template #icon="">
					   <img :src="icon.CustomerActive" class="sServe" />
					 </template>
			   </van-tabbar-item>
			</van-tabbar>
		</div>
	 </div>
</template>

<script>
import listOfItems from '../../components/listOfItems.vue';
import verticalItemList from '../../components/verticalItemList.vue';
import Vue from 'vue'
import { Toast } from 'vant';

Vue.use(Toast);	
export default {
  name: 'shopIndex',
  data() {
    return {
		value:"",
		activeKinds:0,
		collectionActive:1,
		permutation:"vertical",
		shopId:this.$route.query.shop_id,
		shopInfoData:{},
		luckDrawData:[],
		shopAdsData:[],
		kindCount:"",
		showContent:0,
		kindData:[],
		secondTitle:[],
		secondContent:[],
		smallKind:[],
		leftItems: [],
		active:0,
		goosList:[],
		shopGoodsData:[],
		kindActive:0,
		linkPhone:'',
		isios:false,
		 horl:true,
	  toggleBuynum:true,
	  sortString:'',
	  horlString:'',
		icon: {
		        homeActive:require('../../assets/img/icon/iconhome2.png'), 
		        homeinActive:require('../../assets/img/icon/iconhome1.png'),
				sortActive:require('../../assets/img/icon/iconsort2.png'),
				sortinActive:require('../../assets/img/icon/iconsort1.png'), 
				commodityActive:require('../../assets/img/icon/commodity1.png'),
				commodityinActive:require('../../assets/img/icon/commodity.png'), 
				CustomerActive:require('../../assets/img/icon/Customerservice.png'),
		 }
    }
  },
 components: {
 	  listOfItems,
 	  verticalItemList
 },
	mounted(){
		var u = navigator.userAgent;
		this.isios=!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
		if(this.isios){
			 if (screen.height == 812 && screen.width == 375){
					//是iphoneX
			}else{
				this.isios=false
			} 
		}
		// alert(this.isios);
		this.getShopInfo();
		if(this.$route.query.active == undefined){
			this.active= 0;
		}else{
			this.active=this.$route.query.active; 
		}
		this.categoriesData();
		this.getGoodsList();
		localStorage.removeItem('isCart') 
	},
  methods: {
	//    getImgUrl(imgstr){
	// 		  let imgstrs =String(imgstr);
	// 		  return imgstrs.replace(/http/, "https");
	// 	  },
	  getShopInfo(){
		  this.getRequest(`shops/${this.shopId}`).then(res => {
			  this.shopGoodsData = res.data.data.goods;
			  this.shopInfoData = res.data.data.shopInfo;
			  this.collectionActive = res.data.data.shopInfo.is_collected;
			  this.luckDrawData = res.data.data.luckDraw;
			  this.shopAdsData =  res.data.data.shopAds;
			  this.linkPhone = res.data.data.shopInfo.link_phone;
			  console.log(this.shopInfoData)
			})
	  },
	  categoriesData(){
			  let objLeft = {}
			  this.getRequest( `shops/cats/${this.shopId}` ).then(res => {
				  console.log(res.data.data,"66666")
				  this.kindCount=res.data.data.length;
				  this.kindData=res.data.data;
				  console.log(res)
			    res.data.data.map((item) => {
					item.text=item.shop_cat_name; 
					this.leftItems.push({text:item.text});
				})
				this.onFirstNav(0)
			  })
		  },
		  onFirstNav(val){
			 this.kindActive=val;
			 this.smallKind = this.kindData[val].children;
		  },
		  onClickNavs(val){
			 this.kindActive=val;
			 this.smallKind = this.kindData[val].children;
		  },
		  getGoodsList() {
		 	 console.log(this.shopId);
			let param ={
				page_no:this.page_no,
				page_size:this.page_size,
				seller_id:this.shopId
			}
			this.getRequest(`goods/search/searchGoods`, param).then(res => {
				if(res.data.code == 1){
				this.goosList = [];
				}else{
				this.goosList = res.data.data;
				console.log(this.goosList,"this.goosList999999")
				}
			});
			},
			comprehensive(){
				this.getGoodsList();
			},
			salesVolume(){
				this.toggleBuynum = !this.toggleBuynum;
				if(this.toggleBuynum){
					console.log(this.toggleBuynum)
					this.sortString = "buynum_asc"
				}else{
					console.log(this.toggleBuynum)
					this.sortString = 'buynum_desc'
				}
				let param ={
				page_no:this.page_no,
				page_size:this.page_size,
				sort:this.sortString,
				seller_id:this.shopId
				}
				this.getRequest(`goods/search/searchGoods`, param).then(res => {
				if(res.data.code == 1){
				this.goosList = [];
				}else{
				this.goosList = res.data.data;
				console.log(this.goosList,"this.goosList999888")
				}
			});	
			},
			priceSort(){
				 this.horl = !this.horl;
			 	 if(this.horl){
         		this.horlString = 'price_asc'
				}else{
					this.horlString = 'price_desc'
				}
				let param ={
				page_no:this.page_no,
				page_size:this.page_size,
				sort:this.horlString,
				seller_id:this.shopId
				}
				this.getRequest(`goods/search/searchGoods`, param).then(res => {
				if(res.data.code == 1){
				this.goosList = [];
				}else{
				this.goosList = res.data.data;
				console.log(this.goosList,"this.goosList999777")
				}
			});	
			},
  	 togglePermu(){
		 if(this.permutation == 'vertical' ){
			 this.permutation = 'rect'
		 }else{
			this.permutation = 'vertical' 
		 }
	 },
	 collections(){
		 if(localStorage.getItem('isLogin') == 'true'){
		    if(this.collectionActive == 1){
		    			 this.deleteRequest(`members/collection/shop/${this.shopId}`).then(res => {
		    				  this.collectionActive = 0;
		    				  console.log(res.message,"2222")
		    			})
		    }else{
		    			  let param={
		    				 shop_id:this.shopId
		    			 }
		    			 this.postRequest(`members/collection/shop`,param).then(res => {
		    				  this.collectionActive = 1;
		    				  Toast.loading({
		    					message: '收藏成功',
		    					forbidClick: true
		    					});
		    				  console.log(res.message,"1111")
		    			})
		    }
		 }else{
		  this.$router.push({path:'/login'});
		 }
		 
		
	 },
	 goNotice(){
		 this.$router.push('./noticeList')
	 },
	 toService(){
		  this.$router.push({
			  path:'./customerService',
			  query : {
				  shopPhone : this.shopInfoData
			  }
		  })
	 },
	 goLuckDraw(luckIds){
		this.$router.push({
			path : './LuckDraw',
			query :{
				luckid : luckIds
			}
		});
		console.log(luckIds,"luckIds");
	 },
	 goCommodityDetails(){
		 this.$router.push('./goodsDetail') 
	 },
	 goserch(){
		 this.$router.push('./search') 
	 }
	 
	
  }
}
</script>

<style scoped lang='less'>
	.clearfix{
		zoom: 1;
		&::after{
			content: "\20";
			height: 0;
			display: block;
			clear: both;
		}
	}
	.shopIndex{
	   .shopIndexTop{
		   position: fixed;
		   height: 344px;
		   width: 100%;
		   top: 0;
		   z-index: 999;
		   background-color: #fff;
		   .shopIndexBgImg{
			  position: absolute;
			  height: 100%;
			  width: 100%;
			  z-index: 0;
		   }
		  .shopIndexTopBg{
		   background-color:rgba(0,0,0,0.5);
		   position: absolute;
		   height: 100%;
		   width: 100%;
		   z-index: 1;
		   padding-top: 30px;
		.goodListHead{
			  display: flex;
			  justify-content: space-between;
			  background-color: transparent;
			  position: relative;
			  padding: 0 30px;
			  .headLeft{
				  img{
					width: 20px;
					height: 36px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					}
				}
			  .centerSearch{
				width: 90%;
				height: 110px;
				margin-left: -22px;
				/deep/ .van-search{
					background: transparent;
					/deep/ .van-search__content{
						background-color:rgba(242,242,242,0.5);
					  /deep/ .van-field__left-icon{
						  color: #fff;
					  }
					  /deep/ input{
						  color: #fff;
					  }
					  /deep/ input::placeholder{
						  color: #fff;
					  }
					}
				}
			   }		  
			  .headRight{
				  img{
					width: 42px;
					height: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					right: 36px;
					}
				}
			}
		}
		.shopInfo{
			margin-top: 60px;
			.infoLogo{
				margin-left: 44px;
				img{
					width: 64px;
					height: 64px;
					float: left;
					object-fit: cover;
				}
				span{
					font-size: 30px;
					color: #fff;
					margin-top: 10px;
					margin-left: 20px;
					float: left;
				}
			}
			.collection{
				float: right;
				margin-right: 20px;
				img{
					width: 112px;
					height: 48px;
					margin-top: 10px;
				}
			}
		}
	   }
	   .tapBarBox{ 
		   padding-top: 344px;
		   padding-bottom: 100px;
	  .shopIndexContent{
		  background-color: #F5F5F5;
		  padding: 30px;
		 
		 .shopContentList{
			 box-shadow:0px 10px 20px 0px rgba(0,0,0,0.07);
			 border-radius:10px;
			  margin-bottom:20px;
			img{
				width: 100%;
				height: 306px;
			}
			.ContentListText{
				height: 118px;
				background-color: #fff;
				padding: 0 42px;
				line-height: 118px;
				font-size: 26px;
				color: #262626;
			} 
		 } 
	  }
	  .kinds{
		/* height: 100%; */
	.van-tree-select {
		position: absolute;
		width: 100%;
		/deep/ .van-tree-select__nav {
			width: 180px;
			flex: none;
			/deep/ .van-tree-select__nav-item {
				height: 90px;
			}
      
			/deep/ .van-sidebar-item--select {
				position: relative;
				border-color: transparent;
				/deep/ &:before{
					content:"" ;
					position: absolute;
					left: 0;
					top: 28px;
					height: 30px;
					width: 6px;
					background-color:#FF4444;
					border-radius: 4px;
					z-index: 99;
				}
				/deep/ .van-sidebar-item__text {
					font-weight: bold;
				}


			}
		}
		/deep/ .van-tree-select__nav::-webkit-scrollbar {display:none}
		/deep/ .van-tree-select__content::-webkit-scrollbar{display:none}
	}

	.kind {
		padding: 40px;
		width: 100%;
		.kindBox {
			box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
			 padding: 20px 20px 0 20px;
            margin-bottom: 20px;
			.kindTitle {
				font-size: 24px;
				color: #333;
				text-align: left;
				margin: 0;
				margin-bottom: 15px;
			}


			.kindList {
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;

				.kindListBox {
					margin-bottom: 40px;
					/* margin-left: 40px; */
					float: left;
					text-align: center;
					width: 30%;
					margin-left: 5%;
					img {
						width: 130px;
						height: 130px;
						margin: 0 auto;
					}
					p {
						font-size: 22px;
						text-align: center;
						color: #333;
						margin-top: 10px;
					}
				}
				.kindListBox:nth-child(3n+1) {
					margin-left: 0;
				}
			}
		}
	}
	  }
	  .goods{
		 background-color: #f5f5f5;
	   .goodsTopTool{
		  display: flex;
		  height: 86px;
		  line-height: 106px;
		  background-color: #fff;
		  margin-bottom: 20px;
		  .toolBox{
			flex: 1;
			display: flex;
			padding: 0 30px;
			justify-content: space-around;
			div{
				span{
					font-size: 28px;
					color: #333;
				}
				img{
					display: inline-block;
					width: 16px;
					height: 20px;
				}
			}
			
		  }
		  .toolheadRight{
			  width:100px;
			  text-align: center;
			  padding-top: 33px;
			  img{
				 width: 34px;
				 height: 30px;
				 margin: 0 auto;
			  }
		  }
	  }
	  }
	 }
	 .isios{
		 padding-bottom:200px ;
	 }
	 .shopfootNav{
		 /deep/ .van-tabbar{
			.sindex{
				width: 39px;
				height: 36px; 
			 }
			.skinds{
				width: 40px;
				height: 40px;
			}	
			.sgoods{
				width: 38px;
				height: 38px;
			}
			.sServe{
				width: 36px;
				height: 40px;
			}	
					   
		 }
	 }
	
	 
	}
</style>

